exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scores-container[data-v-42cff881]{width:100%}", ""]);

// exports
